import PropTypes from 'prop-types';

const UncheckedIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill={fill} fillRule="nonzero">
          <path d="M24,0 C37.2378947,0 48,10.7621053 48,24 C48,37.2378947 37.2378947,48 24,48 C10.7621053,48 0,37.2378947 0,24 C0,10.7621053 10.7621053,0 24,0 Z M24,4 C12.9712443,4 4,12.9712443 4,24 C4,35.0287557 12.9712443,44 24,44 C35.0287557,44 44,35.0287557 44,24 C44,12.9712443 35.0287557,4 24,4 Z" />
        </g>
      </g>
    </svg>
  </div>
);

UncheckedIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

UncheckedIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default UncheckedIcon;
